/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue, useSetFieldValue } from "formik";
import { useEffect, useRef } from "react";
import * as Yup from "yup";
import { useAvailableTreatments } from "../hooks/useAvailableTreatments";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { InitialRequestConfig } from "../models/flexible/initial-request";
import { combinePaths } from "../models/flexible/utils";
import { Treatment } from "../models/generated/graphql";
import { getPathPrefix } from "../utils/get-path-prefix";
import { GeneralFieldController } from "./general-field-controller";
import { GET_SCOPES, whereDevices } from "./queries";

const SetRefAndLotEffect: React.FC<{ path: string }> = ({ path }) => {
	const [mainItem] = useFieldValue(path) as Array<Treatment>;
	const setFieldValue = useSetFieldValue();
	const code = mainItem?.UDI || "";
	const ref = useRef(code);

	useEffect(() => {
		if (ref.current !== code) {
			ref.current = code;
			setFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.MainItemRef), mainItem?.REF || "");
			setFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.MainItemLot), mainItem?.LOT || "");
		}
	}, [code, mainItem?.LOT, mainItem?.REF, path, setFieldValue]);

	return null;
};

export class MainItemModelFieldController extends GeneralFieldController {
	getInitialRequestComponents?(): InitialRequestConfig {
		return { queries: [GET_SCOPES], variables: { where: whereDevices } };
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable();
	}

	override useControlProps(): FlexControlProps {
		const treatments = useAvailableTreatments(this.parent);
		const mainTreatments = treatments.filter((treatment) => treatment.canBeMain);

		return {
			controlType: "typeahead",
			optionLabel: "Name",
			property: "Code",
			options: mainTreatments,
		};
	}

	override getValueTypeProps() {
		return {
			controlType: "typeahead",
			property: "Name",
		};
	}

	renderBeforeContent(path: string): React.ReactElement {
		return <SetRefAndLotEffect path={path} />;
	}
}
